import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div>
        &copy; {new Date().getFullYear()} Destiny Kids Nursery & Primary School | Juba, South Sudan
      </div>
      <div className={styles.social}>
        <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a>
        <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer">TikTok</a>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a>
      </div>
      <div className={styles.motto}>
        <em>“Knowledge is Wealth”</em>
      </div>
    </footer>
  );
}

export default Footer;
